export const calculateRemainingTime = (expirationTime: string): number => {
  if (!expirationTime) {
    return 0;
  }

  try {
    const now = new Date().getTime();
    const expiration = new Date(expirationTime).getTime();

    if (isNaN(expiration)) {
      return 0;
    }

    const remaining = Math.max(0, Math.floor((expiration - now) / 1000));
    return remaining;
  } catch (error) {
    console.error('Error calculating remaining time:', error);
    return 0;
  }
};

export const isTimerActive = (expirationTime: string): boolean => {
  return calculateRemainingTime(expirationTime) > 0;
};

export const formatTimerDigits = (seconds: number): string => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;

  const formattedMinutes = String(minutes).padStart(2, '0');
  const formattedSeconds = String(remainingSeconds).padStart(2, '0');

  return `${formattedMinutes}:${formattedSeconds}`;
};

export const getMfaCodeResendTime = (authState: {
  mfaCodeResendTime?: string;
}): string | undefined => {
  return authState?.mfaCodeResendTime;
};
